import {
  Col,
  Row,
  Space,
  Table,
  Card,
  Spin,
  message,
  Divider,
  Button,
  Typography,
  Dropdown,
  Input,
} from "antd";
import React, { useMemo, useState } from "react";
import {
  PrinterOutlined,
  FilePdfOutlined,
  FileExcelOutlined,
  DownOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import {
  HEADERS_EXPORT_DETAIL,
  POST_REPORT_MANAGER_ACC,
} from "../../API/apiUrls";
import CurrencyFormat from "../../../hook/CurrencyFormat";
import "../../../assets/font/THSarabunNew-normal";
import "../../../assets/font/THSarabunNew-bold";
import MotionHoc from "../../../utils/MotionHoc";
import TokenCheck from "../../../hook/TokenCheck";
import XLSX from "xlsx-js-style";
import ThaiDatePicker from "../../../hook/ThaiDatePicker";

const { Text } = Typography;

const getContractType = (r) =>
  r.flagLoanNew === 1 ? "ทำยอม" : r.flagLoanNew === 2 ? "พิพากษา" : "";

//แยกรับอื่น ๆ กับค่างวด
// const getRowValues = (r) => {
//   const payamt = parseFloat(r.PAYAMT) || 0;
//   const payamtN = parseFloat(r.PAYAMT_N) || 0;
//   const creditDebtor = parseFloat(r.creditDebtor) || 0;
//   const disct = parseFloat(r.DISCT) || 0;
//   const payamtV = parseFloat(r.PAYAMT_V) || 0;
//   const netpay = parseFloat(r.NETPAY) || 0;

//   // ค่างวด
//   let installment = 0;
//   if (r.flagLoanNew === 1 && payamtN) {
//     installment = payamtN;
//   } else if (r.flagLoanNew === 2 && r.PAYFOR === "888" && payamtN) {
//     installment = creditDebtor > payamtN ? payamtN : creditDebtor;
//   }

//   // รับอื่นๆ
//   let other = 0;
//   if (r.flagLoanNew === 2) {
//     if (r.PAYFOR !== "888" && netpay) {
//       other = netpay;
//     } else if (r.PAYFOR === "888" && payamt > creditDebtor) {
//       other = payamt - creditDebtor;
//     }
//   }

//   // ดอกเบี้ย — แสดงเฉพาะ flagLoanNew === 1
//   const interestDiscount = r.flagLoanNew === 1 ? payamtV : 0;

//   return {
//     installment, // ค่างวด
//     other, // รับอื่นๆ
//     netReceived: netpay, // รวมรับสุทธิ (NETPAY)
//     disct,
//     payamtV: interestDiscount,
//     cashPay: r.PAYTYP === "01" ? netpay : 0,
//     transferPay: r.PAYTYP !== "01" ? netpay : 0,
//   };
// };

// const getRowValues = (r) => {
//   const payamt = parseFloat(r.PAYAMT) || 0;
//   const payamtN = parseFloat(r.PAYAMT_N) || 0;
//   const creditDebtor = parseFloat(r.creditDebtor) || 0;
//   const disct = parseFloat(r.DISCT) || 0;
//   const payamtV = parseFloat(r.PAYAMT_V) || 0;
//   const netpay = parseFloat(r.NETPAY) || 0;

//   // ค่างวด
//   let installment = 0;
//   if (r.flagLoanNew === 1 && payamtN) {
//     installment = payamtN;
//   } else if (r.flagLoanNew === 2 && r.PAYFOR === "888" && payamtN) {
//     installment = creditDebtor > payamtN ? payamtN : creditDebtor;
//   }

//   // รับอื่นๆ
//   if (r.flagLoanNew === 2) {
//     if (r.PAYFOR !== "888" && netpay) {
//       installment = netpay;
//     } else if (r.PAYFOR === "888" && payamt > creditDebtor) {
//       installment = payamt - creditDebtor;
//     }
//   }

//   // ดอกเบี้ย — แสดงเฉพาะ flagLoanNew === 1
//   const interestDiscount = r.flagLoanNew === 1 ? payamtV : 0;

//   return {
//     installment, // ค่างวด
//     netReceived: netpay, // รวมรับสุทธิ (NETPAY)
//     disct,
//     payamtV: interestDiscount,
//     cashPay: r.PAYTYP === "01" ? netpay : 0,
//     transferPay: r.PAYTYP !== "01" ? netpay : 0,
//   };
// };

//แก้เมื่อ 06/07/2026

const getRowValues = (r) =>
  r._calc ?? {
    installment: 0,
    other: 0,
    penalty: parseFloat(r.PAYAMT_V) || 0,
    netReceived: parseFloat(r.NETPAY) || 0,
    disct: parseFloat(r.DISCT) || 0,
    payamtV: 0,
    cashPay: 0,
    transferPay: 0,
  };

// คำนวณค่าแบบ running balance ต่อ CONTNO
// ⚠️ ต้องส่ง list ที่ sort ตาม PAYDT แล้วเท่านั้น
const computeRowValues = (sortedList = []) => {
  const remainMap = new Map(); // CONTNO → creditDebtor คงเหลือ

  return sortedList.map((r) => {
    const payamt = parseFloat(r.PAYAMT) || 0;
    const payamtN = parseFloat(r.PAYAMT_N) || 0;
    const payamtV = parseFloat(r.PAYAMT_V) || 0;
    const disct = parseFloat(r.DISCT) || 0;
    const netpay = parseFloat(r.NETPAY) || 0;
    const creditDebtor = parseFloat(r.creditDebtor) || 0;

    let installment = 0; // ค่างวด
    let other = 0; // รับอื่นๆ
    let interest = 0; // ดอกเบี้ย
    const penalty = payamtV; // ปรับ = PAYAMT_V เสมอ

    if (r.flagLoanNew === 1) {
      // ทำยอม — PAYAMT_V ย้ายไปช่องปรับ ดอกเบี้ยจึงเป็น 0
      installment = payamtN;
    } else if (r.flagLoanNew === 2) {
      // พิพากษา — ทุกแถวหักจากโควตา creditDebtor ร่วมกันของ CONTNO
      if (!remainMap.has(r.CONTNO)) remainMap.set(r.CONTNO, creditDebtor);
      const remaining = remainMap.get(r.CONTNO);

      const paid = payamt - payamtV;
      const used = Math.min(paid, remaining);
      const excess = paid - used;

      installment = used;

      console.log("remaining", remaining);
      console.log("paid", paid);
      console.log("used", used);
      console.log("paid", excess);
      console.log("installment", installment);

      if (r.FLAG !== "C") {
        remainMap.set(r.CONTNO, remaining - used);
      }

      if (excess > 0) {
        if (payamtV !== 0) {
          // ส่วนเกิน: หักเข้าปรับ (PAYAMT_V) ก่อน เศษที่เหลือไปดอกเบี้ย
          interest = Math.max(excess - payamtV, 0);
          console.log("interest", interest);
        } else {
          other = excess;
          console.log("other", other);
        }
      }
      // ไม่มีส่วนเกิน → ดอกเบี้ย 0 (PAYAMT_V แสดงที่ช่องปรับแล้ว)
    }

    return {
      ...r,
      _calc: {
        installment,
        other,
        penalty, // ← เพิ่ม
        netReceived: netpay,
        disct,
        payamtV: interest,
        cashPay: r.PAYTYP === "01" ? netpay : 0,
        transferPay: r.PAYTYP !== "01" ? netpay : 0,
      },
    };
  });
};

// ✅ สรุปยอด — บวกจากค่าที่ผ่าน logic ตาราง
const calcTotals = (rows) =>
  rows.reduce(
    (acc, r) => {
      const v = getRowValues(r);
      return {
        installment: acc.installment + v.installment,
        other: acc.other + v.other,
        netReceived: acc.netReceived + v.netReceived,
        disct: acc.disct + v.disct,
        payamtV: acc.payamtV + v.payamtV,
        cashPay: acc.cashPay + v.cashPay,
        transferPay: acc.transferPay + v.transferPay,
        penalty: acc.penalty + v.penalty,
      };
    },
    {
      installment: 0,
      other: 0,
      netReceived: 0,
      disct: 0,
      payamtV: 0,
      cashPay: 0,
      transferPay: 0,
      penalty: 0,
    },
  );

// ฟิลด์เงินที่ต้องรวมยอด
const MONEY_FIELDS = ["PAYAMT", "PAYAMT_N", "PAYAMT_V", "DISCT", "NETPAY"];

// รวมรายการ AR ที่ TMBILL + CONTNO เหมือนกันเป็น obj เดียว
const mergeArPayments = (list = []) => {
  const result = [];
  const arMap = new Map(); // key = TMBILL|CONTNO → index ใน result

  for (const item of list) {
    // รวมเฉพาะ AR — ประเภทอื่น (เช่น NR) ผ่านไปตามเดิม
    if (item.PAY_TYPE !== "AR") {
      result.push(item);
      continue;
    }

    const key = `${item.TMBILL}|${item.CONTNO}`;

    if (!arMap.has(key)) {
      // เจอครั้งแรก — clone ไว้กันแก้ object ต้นฉบับ
      arMap.set(key, result.length);
      result.push({ ...item });
    } else {
      // เจอซ้ำ — บวกยอดเงินเข้า obj เดิม
      const merged = result[arMap.get(key)];
      for (const f of MONEY_FIELDS) {
        merged[f] = String(Number(merged[f] || 0) + Number(item[f] || 0));
      }
      // ต่อรายละเอียดรายการ เช่น "ดอกเบี้ยก่อนฟ้อง, ค่าเร่งเล่ม"
      if (item.FORDESC && !merged.FORDESC.includes(item.FORDESC)) {
        merged.FORDESC = `${merged.FORDESC}, ${item.FORDESC}`;
      }
      // เก็บ PAYFOR / CH_CONTNO ที่ต่างกันไว้ด้วย (เผื่อใช้ตอนพิมพ์)
      if (item.PAYFOR && !String(merged.PAYFOR).includes(item.PAYFOR)) {
        merged.PAYFOR = `${merged.PAYFOR},${item.PAYFOR}`;
      }
    }
  }

  return result;
};

const Main = () => {
  const [
    currencyFormat,
    currencyFormatComma,
    currencyFormatPoint,
    currencyFormatNoPoint,
  ] = CurrencyFormat();

  const [loading, setLoading] = useState(false);
  const [arrayPay, setArrayPay] = useState([]);
  const [company, setCompany] = useState(null);
  const [startDate, setStartDate] = useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs());
  const [signOut] = TokenCheck();
  const [searchText, setSearchText] = useState("");

  const filteredData = useMemo(() => {
    const keyword = searchText.trim().toLowerCase();
    if (!keyword) return arrayPay;
    return arrayPay.filter((r) => {
      const contno = String(r.newContno ?? "").toLowerCase();
      const tmbill = String(r.TMBILL ?? "").toLowerCase();
      return contno.includes(keyword) || tmbill.includes(keyword);
    });
  }, [arrayPay, searchText]);

  const onQuery = () => {
    if (!startDate || !endDate) {
      message.warning("กรุณาเลือกวันที่ก่อนค้นหา");
      return;
    }
    queryData({
      firstDate: dayjs(startDate).format("YYYY-MM-DDTHH:mm:ssZ"),
      lastDate: dayjs(endDate).format("YYYY-MM-DDTHH:mm:ssZ"),
    });
  };

  const queryData = async (payload) => {
    setLoading(true);
    try {
      const res = await axios.post(POST_REPORT_MANAGER_ACC, payload, {
        headers: HEADERS_EXPORT_DETAIL,
      });

      if (res.status === 200) {
        const merged = mergeArPayments(res.data.pay ?? []);
        const sorted = merged.slice().sort((a, b) => {
          const dateDiff = dayjs(a.PAYDT).valueOf() - dayjs(b.PAYDT).valueOf();
          if (dateDiff !== 0) return dateDiff;
          return String(a.newContno ?? "").localeCompare(
            String(b.newContno ?? ""),
          );
        });
        const computed = computeRowValues(sorted); // ← เพิ่มบรรทัดนี้

        setArrayPay(computed);
        console.log("computed", computed);

        setCompany(res.data.company?.[0] ?? res.data.Company?.[0] ?? null);
      } else {
        setArrayPay([]);
      }
    } catch (err) {
      console.error(err);
      message.error(
        err?.response?.status > 401
          ? "ไม่พบข้อมูล"
          : "เกิดข้อผิดพลาดในการดึงข้อมูล",
      );
      setArrayPay([]);
      if (err?.response?.status === 401) {
        signOut();
      }
    } finally {
      setLoading(false);
    }
  };

  const fmt = (val) => (val ? currencyFormatPoint(val) : "");
  const fmtPos = (val) => (parseFloat(val) > 0 ? currencyFormatPoint(val) : "");

  // ──────────────────────────────
  // Columns (19 columns)
  // ──────────────────────────────
  const columns = [
    {
      title: "ลำดับ",
      align: "center",
      width: 50,
      render: (_, __, i) => i + 1,
    },
    {
      title: "สาขา",
      dataIndex: "LOCAT",
      key: "LOCAT",
      align: "center",
      width: 60,
    },
    {
      title: "เลขที่ใบรับ",
      dataIndex: "TMBILL",
      key: "TMBILL",
      align: "center",
      width: 120,
    },
    {
      title: "วันที่รับ",
      dataIndex: "PAYDT",
      key: "PAYDT",
      align: "center",
      width: 100,
      sorter: (a, b) => dayjs(a.PAYDT).valueOf() - dayjs(b.PAYDT).valueOf(),
      render: (val) => (val ? dayjs(val).format("DD/MM/YYYY") : "-"),
    },
    {
      title: "เลขที่สัญญา/ชื่อ",
      align: "center",
      width: 130,
      render: (_, record) => record.newContno,
    },
    {
      title: "ประเภท",
      dataIndex: "PAYTYP",
      key: "PAYTYP",
      align: "center",
      width: 65,
    },
    {
      title: "ประเภทสัญญา",
      align: "center",
      width: 90,
      render: (_, r) => getContractType(r) || null,
    },
    {
      title: "ค่างวด",
      align: "right",
      width: 90,
      sorter: (a, b) =>
        getRowValues(a).installment - getRowValues(b).installment,
      render: (_, r) => {
        const v = getRowValues(r).installment;
        return v ? fmt(v) : 0;
      },
    },
    { title: "ดาวน์", align: "right", width: 80, render: () => null },
    {
      title: "ปรับ",
      align: "right",
      width: 80,
      sorter: (a, b) => getRowValues(a).penalty - getRowValues(b).penalty,
      render: (_, r) => {
        const v = getRowValues(r).penalty;
        return v ? fmt(v) : 0;
      },
    },
    { title: "ขายสด", align: "right", width: 80, render: () => null },
    {
      title: "เงินจอง",
      align: "right",
      width: 80,
      render: (_, r) =>
        r.FLAG === "C" ? (
          <Text style={{ color: "#e74c3c", fontWeight: "bold" }}>
            **ยกเลิก**
          </Text>
        ) : null,
    },
    {
      title: "รับอื่นๆ",
      align: "right",
      width: 80,
      sorter: (a, b) => getRowValues(a).other - getRowValues(b).other,
      render: (_, r) => {
        const v = getRowValues(r).other;
        return v ? fmt(v) : 0;
      },
    },
    {
      title: "ส่วนลด",
      key: "DISCT",
      align: "right",
      width: 80,
      sorter: (a, b) => (a.DISCT ?? 0) - (b.DISCT ?? 0),
      render: (_, record) => fmt(record.DISCT || 0),
    },
    {
      title: "ดอกเบี้ย",
      align: "right",
      width: 90,
      sorter: (a, b) => getRowValues(a).payamtV - getRowValues(b).payamtV,
      render: (_, r) => {
        const v = getRowValues(r).payamtV;
        return v ? fmt(v) : 0;
      },
    },
    {
      title: "เงินสด",
      align: "right",
      width: 90,
      sorter: (a, b) => getRowValues(a).cashPay - getRowValues(b).cashPay,
      render: (_, r) => {
        const v = getRowValues(r).cashPay;
        return v ? fmt(v) : 0;
      },
    },
    {
      title: "เงินโอน",
      align: "right",
      width: 90,
      sorter: (a, b) =>
        getRowValues(a).transferPay - getRowValues(b).transferPay,
      render: (_, r) => {
        const v = getRowValues(r).transferPay;
        return v ? fmt(v) : 0;
      },
    },
    {
      title: "เงินรับฝากค่างวด",
      align: "right",
      width: 120,
      render: () => null,
    },
    {
      title: "รวมรับสุทธิ",
      align: "right",
      width: 120,
      sorter: (a, b) =>
        getRowValues(a).netReceived - getRowValues(b).netReceived,
      render: (_, r) => fmt(getRowValues(r).netReceived),
    },
  ];

  const exportMenuItems = {
    items: [
      {
        key: "pdf",
        label: "Export PDF",
        icon: <FilePdfOutlined style={{ color: "#c0392b" }} />,
      },
      {
        key: "excel",
        label: "Export Excel",
        icon: <FileExcelOutlined style={{ color: "#27ae60" }} />,
      },
    ],
    onClick: ({ key }) => {
      if (key === "pdf") handlePrintPDF();
      if (key === "excel") handleExportExcel();
    },
  };

  const rowClassName = (record) => (record.FLAG === "C" ? "row-cancelled" : "");

  // ──────────────────────────────
  // PDF
  // ──────────────────────────────
  const handlePrintPDF = () => {
    if (!filteredData.length) {
      message.warning("ไม่มีข้อมูลสำหรับพิมพ์");
      return;
    }

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });
    const pageWidth = doc.internal.pageSize.getWidth();
    const now = dayjs().format("DD/MM/YYYY HH:mm:ss");
    const fromDate = startDate ? dayjs(startDate).format("DD/MM/YYYY") : "";
    const toDate = endDate ? dayjs(endDate).format("DD/MM/YYYY") : "";

    const drawHeader = (pageNum) => {
      if (pageNum === 1) {
        doc.setFont("THSarabunNew", "bold");
        doc.setFontSize(16);
        doc.text("รายงานการรับชำระประจำวันผู้ตรวจสอบ", pageWidth / 2, 10, {
          align: "center",
        });
        doc.setFont("THSarabunNew", "normal");
        doc.setFontSize(14);
        doc.text(company?.COMP_NM ?? "", pageWidth / 2, 17, {
          align: "center",
        });
        doc.text(company?.COMP_ADR1 ?? "", pageWidth / 2, 23, {
          align: "center",
        });
        doc.text(
          `จากวันที่  ${fromDate}   ถึงวันที่  ${toDate}`,
          pageWidth / 2,
          29,
          { align: "center" },
        );
        doc.setFontSize(12);
        doc.text(`วันที่พิมพ์ ${now}`, 8, 35);
        doc.text(`หน้าที่  ${pageNum}`, pageWidth - 8, 35, { align: "right" });
      } else {
        doc.setFont("THSarabunNew", "normal");
        doc.setFontSize(12);
        doc.text(`วันที่พิมพ์ ${now}`, 8, 8);
        doc.text(`หน้าที่  ${pageNum}`, pageWidth - 8, 8, { align: "right" });
      }
    };

    // ✅ 19 columns ตรงตาราง
    const head = [
      [
        "ลำดับ",
        "สาขา",
        "เลขที่ใบรับ",
        "วันที่รับ",
        "เลขที่สัญญา/ชื่อ",
        "ประเภท",
        "ประเภทสัญญา",
        "ค่างวด",
        "ดาวน์",
        "ปรับ",
        "ขายสด",
        "เงินจอง",
        "รับอื่นๆ",
        "ส่วนลด",
        "ดอกเบี้ย",
        "เงินสด",
        "เงินโอน",
        "เงินรับฝากค่างวด",
        "รวมรับสุทธิ",
      ],
    ];

    const tableBody = filteredData.map((r, i) => {
      const v = getRowValues(r);
      const cancelled = r.FLAG === "C";
      return [
        i + 1, // ลำดับ
        r.LOCAT ?? "",
        r.TMBILL ?? "",
        r.PAYDT ? dayjs(r.PAYDT).format("DD/MM/YYYY") : "",
        r.newContno ?? "",
        r.PAYTYP ?? "",
        getContractType(r), // ประเภทสัญญา
        v.installment > 0 ? fmt(v.installment) : "0", // ค่างวด
        "", // ดาวน์
        v.penalty > 0 ? fmt(v.penalty) : "0", // ปรับ
        "", // ขายสด
        cancelled ? "**ยกเลิก**" : "0", // เงินจอง
        v.other > 0 ? fmt(v.other) : "0", // รับอื่นๆ
        v.disct > 0 ? fmt(v.disct) : "0", // ส่วนลด
        v.payamtV > 0 ? fmt(v.payamtV) : "0", // ดอกเบี้ย
        v.cashPay > 0 ? fmt(v.cashPay) : "", // เงินสด
        v.transferPay > 0 ? fmt(v.transferPay) : "", // เงินโอน
        "", // เงินรับฝากค่างวด
        v.netReceived > 0 ? fmt(v.netReceived) : "", // รวมรับสุทธิ
      ];
    });

    const cancelledRows = filteredData.filter((r) => r.FLAG === "C");
    const validRows = filteredData.filter((r) => r.FLAG !== "C");
    const totalsAll = calcTotals(filteredData);
    const totalsCancelled = calcTotals(cancelledRows);
    const totalsValid = calcTotals(validRows);

    const makeSummaryRow = (
      label,
      count,
      t,
      textColor = [0, 0, 0],
      fillColor = [236, 240, 241],
    ) => {
      const cell = (content) => ({
        content,
        styles: {
          halign: "right",
          fontStyle: "bold",
          font: "THSarabunNew",
          fillColor,
          textColor,
        },
      });
      return [
        {
          content: `${label}  ${count} รายการ  จำนวนเงิน`,
          colSpan: 7, // ✅ ลำดับ → ประเภทสัญญา = 7 columns
          styles: {
            halign: "right",
            fontStyle: "bold",
            font: "THSarabunNew",
            fillColor,
            textColor,
          },
        },
        cell(t.installment > 0 ? currencyFormatPoint(t.installment) : ""),
        cell(""), // ดาวน์
        cell(t.penalty > 0 ? currencyFormatPoint(t.penalty) : ""), // ปรับ
        cell(""), // ขายสด
        cell(""), // เงินจอง
        cell(t.other > 0 ? currencyFormatPoint(t.other) : ""),
        cell(t.disct > 0 ? currencyFormatPoint(t.disct) : ""),
        cell(t.payamtV > 0 ? currencyFormatPoint(t.payamtV) : ""),
        cell(t.cashPay > 0 ? currencyFormatPoint(t.cashPay) : ""),
        cell(t.transferPay > 0 ? currencyFormatPoint(t.transferPay) : ""),
        cell(""), // เงินรับฝากค่างวด
        cell(t.netReceived > 0 ? currencyFormatPoint(t.netReceived) : ""),
      ];
    };

    const summaryRows = [
      makeSummaryRow("รวมทั้งหมด", filteredData.length, totalsAll),
      makeSummaryRow(
        "รวมยกเลิกทั้งหมด",
        cancelledRows.length,
        totalsCancelled,
        [220, 53, 69],
        [255, 235, 235],
      ),
      makeSummaryRow(
        "รวมรับชำระจริง",
        validRows.length,
        totalsValid,
        [21, 87, 36],
        [212, 237, 218],
      ),
    ];

    doc.autoTable({
      startY: 38,
      head,
      body: [...tableBody, ...summaryRows],
      styles: {
        font: "THSarabunNew",
        fontSize: 11,
        cellPadding: 1.2,
        halign: "center",
      },
      headStyles: {
        font: "THSarabunNew",
        fillColor: [52, 73, 94],
        textColor: 255,
        halign: "center",
        fontStyle: "bold",
        fontSize: 12,
      },
      alternateRowStyles: { fillColor: [250, 250, 250] },
      didParseCell: (data) => {
        if (data.section === "body" && data.row.index < tableBody.length) {
          const row = filteredData[data.row.index];
          if (row?.FLAG === "C") {
            data.cell.styles.textColor = [220, 53, 69];
            data.cell.styles.fontStyle = "bold";
          }
        }
      },
      didDrawPage: () =>
        drawHeader(doc.internal.getCurrentPageInfo().pageNumber),
      tableWidth: "auto",
      margin: { top: 41, left: 3, right: 3 },
    });

    doc.save(`รายงานผู้ตรวจสอบ_${fromDate}_${toDate}.pdf`);
  };

  // ──────────────────────────────
  // Excel
  // ──────────────────────────────
  const handleExportExcel = () => {
    if (!filteredData.length) {
      message.warning("ไม่มีข้อมูล");
      return;
    }

    const cancelledRows = filteredData.filter((r) => r.FLAG === "C");
    const validRows = filteredData.filter((r) => r.FLAG !== "C");
    const totalsAll = calcTotals(filteredData);
    const totalsCancelled = calcTotals(cancelledRows);
    const totalsValid = calcTotals(validRows);

    const rows = filteredData.map((r, index) => {
      const v = getRowValues(r);
      return {
        ลำดับ: index + 1,
        สาขา: r.LOCAT ?? "",
        เลขที่ใบรับ: r.TMBILL ?? "",
        วันที่รับ: r.PAYDT ? dayjs(r.PAYDT).format("DD/MM/YYYY") : "",
        "เลขที่สัญญา/ชื่อ": r.newContno ?? "",
        ประเภท: r.PAYTYP ?? "",
        ประเภทสัญญา: getContractType(r),
        ค่างวด: v.installment,
        ดาวน์: 0,
        ปรับ: v.penalty,
        ขายสด: 0,
        เงินจอง: r.FLAG === "C" ? "ยกเลิก" : 0,
        รับอื่นๆ: v.other,
        ส่วนลด: v.disct,
        ดอกเบี้ย: v.payamtV,
        เงินสด: v.cashPay,
        เงินโอน: v.transferPay,
        เงินรับฝากค่างวด: 0,
        รวมรับสุทธิ: v.netReceived,
      };
    });

    const keys = Object.keys(rows[0]);
    const moneyKeys = [
      "ค่างวด",
      "ดาวน์",
      "ปรับ",
      "ขายสด",
      "รับอื่นๆ",
      "ส่วนลด",
      "ดอกเบี้ย",
      "เงินสด",
      "เงินโอน",
      "เงินรับฝากค่างวด",
      "รวมรับสุทธิ",
    ];

    const makeSummaryRow = (label, count, t) => {
      const row = Object.fromEntries(keys.map((k) => [k, ""]));
      row["เลขที่ใบรับ"] = `${label}  ${count} รายการ`;
      row["ค่างวด"] = t.installment || 0;
      row["ปรับ"] = t.penalty || 0;
      row["รับอื่นๆ"] = t.other || 0;
      row["ส่วนลด"] = t.disct || 0;
      row["ดอกเบี้ย"] = t.payamtV || 0;
      row["เงินสด"] = t.cashPay || 0;
      row["เงินโอน"] = t.transferPay || 0;
      row["รวมรับสุทธิ"] = t.netReceived || 0;
      return row;
    };

    const sumAll = makeSummaryRow("รวมทั้งหมด", filteredData.length, totalsAll);
    const sumCancelled = makeSummaryRow(
      "รวมยกเลิกทั้งหมด",
      cancelledRows.length,
      totalsCancelled,
    );
    const sumValid = makeSummaryRow(
      "รวมรับชำระจริง",
      validRows.length,
      totalsValid,
    );

    const border = {
      top: { style: "thin", color: { rgb: "CCCCCC" } },
      bottom: { style: "thin", color: { rgb: "CCCCCC" } },
      left: { style: "thin", color: { rgb: "CCCCCC" } },
      right: { style: "thin", color: { rgb: "CCCCCC" } },
    };
    const fills = {
      even: { patternType: "solid", fgColor: { rgb: "EBF5FF" } },
      odd: { patternType: "solid", fgColor: { rgb: "FFFFFF" } },
      cancel: { patternType: "solid", fgColor: { rgb: "FDECEA" } },
      header: { patternType: "solid", fgColor: { rgb: "34495E" } },
      sumAll: { patternType: "solid", fgColor: { rgb: "ECF0F1" } },
      sumCancel: { patternType: "solid", fgColor: { rgb: "FFEBEB" } },
      sumValid: { patternType: "solid", fgColor: { rgb: "D5E8D4" } },
    };

    const ws = XLSX.utils.json_to_sheet([
      ...rows,
      sumAll,
      sumCancelled,
      sumValid,
    ]);

    // header
    keys.forEach((_, ci) => {
      const ref = XLSX.utils.encode_cell({ r: 0, c: ci });
      if (!ws[ref]) return;
      ws[ref].s = {
        fill: fills.header,
        font: { bold: true, sz: 12, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "center", vertical: "center" },
        border,
      };
    });

    // data rows
    rows.forEach((row, ri) => {
      const isCancel = row["เงินจอง"] === "ยกเลิก";
      keys.forEach((key, ci) => {
        const ref = XLSX.utils.encode_cell({ r: ri + 1, c: ci });
        if (!ws[ref]) ws[ref] = { v: "", t: "s" };
        const isMoney = moneyKeys.includes(key);
        ws[ref].s = {
          fill: isCancel ? fills.cancel : ri % 2 === 0 ? fills.even : fills.odd,
          font: {
            sz: 11,
            color: isCancel ? { rgb: "E74C3C" } : { rgb: "000000" },
            bold: isCancel,
          },
          alignment: {
            horizontal: isMoney ? "right" : "center",
            vertical: "center",
          },
          border,
          numFmt:
            isMoney && typeof row[key] === "number" ? "#,##0.00" : undefined,
        };
      });
    });

    // summary rows
    const summaryDefs = [
      { offset: 1, fill: fills.sumAll, color: "000000" },
      { offset: 2, fill: fills.sumCancel, color: "DC3545" },
      { offset: 3, fill: fills.sumValid, color: "155724" },
    ];
    summaryDefs.forEach(({ offset, fill, color }) => {
      const ri = rows.length + offset;
      keys.forEach((key, ci) => {
        const ref = XLSX.utils.encode_cell({ r: ri, c: ci });
        if (!ws[ref]) return;
        const isMoney = moneyKeys.includes(key);
        ws[ref].s = {
          fill,
          font: { bold: true, sz: 12, color: { rgb: color } },
          alignment: {
            horizontal: isMoney ? "right" : "left",
            vertical: "center",
          },
          border,
          numFmt: isMoney ? "#,##0.00" : undefined,
        };
      });
    });

    // column width
    const colWidthMap = {
      ลำดับ: 6,
      สาขา: 8,
      เลขที่ใบรับ: 22,
      วันที่รับ: 12,
      "เลขที่สัญญา/ชื่อ": 18,
      ประเภท: 10,
      ประเภทสัญญา: 12,
      ค่างวด: 14,
      ดาวน์: 10,
      ปรับ: 10,
      ขายสด: 10,
      เงินจอง: 12,
      รับอื่นๆ: 12,
      ส่วนลด: 12,
      ดอกเบี้ย: 12,
      เงินสด: 12,
      เงินโอน: 12,
      เงินรับฝากค่างวด: 18,
      รวมรับสุทธิ: 14,
    };
    ws["!cols"] = keys.map((k) => ({ wch: colWidthMap[k] ?? 14 }));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "รายงาน");
    XLSX.writeFile(wb, `รายงานผู้ตรวจสอบ_${dayjs().format("DDMMYYYY")}.xlsx`);
    message.success("Export Excel สำเร็จ");
  };

  const hasDate = startDate && endDate;

  return (
    <>
      <style>{`
        .row-cancelled td {
          color: #e74c3c !important;
          font-weight: bold;
        }
      `}</style>

      <Spin spinning={loading} size="large" tip="Loading...">
        <Row>
          <Col span={16} style={{ textAlign: "start" }}>
            <Space style={{ marginBottom: 10 }} wrap>
              เริ่ม
              <ThaiDatePicker
                size="large"
                value={startDate}
                onChange={setStartDate}
                placeholder={"วันที่เริ่มต้น"}
                allowClear={false}
              />
              ถึง
              <ThaiDatePicker
                size="large"
                value={endDate}
                onChange={setEndDate}
                placeholder={"วันที่สิ้นสุด"}
                allowClear={false}
              />
              <Button size="large" type="primary" onClick={onQuery}>
                ค้นหา
              </Button>
              <Input
                size="small"
                allowClear
                placeholder="ค้นหาเลขที่สัญญา / เลขที่ใบรับ"
                prefix={<SearchOutlined />}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                style={{ width: 220 }}
              />
            </Space>
          </Col>
          <Col span={8} style={{ textAlign: "end" }}>
            <Space style={{ marginBottom: 10 }}>
              <Dropdown menu={exportMenuItems} disabled={!filteredData.length}>
                <Button size="large" icon={<PrinterOutlined />}>
                  พิมพ์ / Export <DownOutlined />
                </Button>
              </Dropdown>
            </Space>
          </Col>
        </Row>

        <Card style={{ marginBottom: "10px" }}>
          <Divider style={{ fontSize: 20 }}>
            รายงานการรับชำระประจำวันผู้ตรวจสอบ
          </Divider>

          {company && (
            <div style={{ marginBottom: 4, textAlign: "center" }}>
              <Typography.Text
                strong
                style={{ display: "block", fontSize: 16 }}
              >
                {company.COMP_NM}
              </Typography.Text>
              <Typography.Text
                type="secondary"
                style={{ display: "block", fontSize: 16 }}
              >
                {company.COMP_ADR1}
              </Typography.Text>
            </div>
          )}

          {hasDate && (
            <Typography.Text
              style={{ display: "block", textAlign: "center", fontSize: 16 }}
            >
              จากวันที่ {dayjs(startDate).format("DD/MM/YYYY")} ถึงวันที่{" "}
              {dayjs(endDate).format("DD/MM/YYYY")}
            </Typography.Text>
          )}

          <Table
            style={{ marginTop: "10px" }}
            size="small"
            columns={columns}
            dataSource={filteredData}
            rowKey={(record) =>
              record.wctId ?? `${record.TMBILL}-${record.CONTNO}`
            }
            rowClassName={rowClassName}
            scroll={{ x: 1600 }}
            pagination={{
              defaultPageSize: 50,
              showSizeChanger: true,
              showTotal: (total) => `ทั้งหมด ${total} รายการ`,
              pageSizeOptions: ["10", "20", "50", "100"],
            }}
            summary={() => {
              const cancelledRows = filteredData.filter((r) => r.FLAG === "C");
              const validRows = filteredData.filter((r) => r.FLAG !== "C");
              const totalsAll = calcTotals(filteredData);
              const totalsCancelled = calcTotals(cancelledRows);
              const totalsValid = calcTotals(validRows);

              const SummaryRow = ({
                label,
                count,
                t,
                style = {},
                cellStyle = {},
              }) => (
                <Table.Summary.Row
                  style={{
                    background: "#ecf0f1",
                    fontWeight: "bold",
                    ...style,
                  }}
                >
                  {/* ลำดับ → ประเภทสัญญา = 7 columns */}
                  <Table.Summary.Cell
                    colSpan={7}
                    align="right"
                    style={cellStyle}
                  >
                    {label} {count} รายการ จำนวนเงิน :
                  </Table.Summary.Cell>

                  {/* ค่างวด */}
                  <Table.Summary.Cell align="right" style={cellStyle}>
                    {t.installment ? fmtPos(t.installment) : null}
                  </Table.Summary.Cell>

                  {/* ดาวน์ — empty */}
                  <Table.Summary.Cell />

                  {/* ปรับ */}
                  <Table.Summary.Cell align="right" style={cellStyle}>
                    {t.penalty ? fmtPos(t.penalty) : null}
                  </Table.Summary.Cell>

                  {/* ขายสด, เงินจอง — empty */}
                  <Table.Summary.Cell />
                  <Table.Summary.Cell />

                  {/* รับอื่นๆ */}
                  <Table.Summary.Cell align="right" style={cellStyle}>
                    {t.other ? fmtPos(t.other) : null}
                  </Table.Summary.Cell>

                  {/* ส่วนลด */}
                  <Table.Summary.Cell align="right" style={cellStyle}>
                    {t.disct ? fmtPos(t.disct) : null}
                  </Table.Summary.Cell>

                  {/* ดอกเบี้ย */}
                  <Table.Summary.Cell align="right" style={cellStyle}>
                    {t.payamtV ? fmtPos(t.payamtV) : null}
                  </Table.Summary.Cell>

                  {/* เงินสด */}
                  <Table.Summary.Cell align="right" style={cellStyle}>
                    {t.cashPay ? fmtPos(t.cashPay) : null}
                  </Table.Summary.Cell>

                  {/* เงินโอน */}
                  <Table.Summary.Cell align="right" style={cellStyle}>
                    {t.transferPay ? fmtPos(t.transferPay) : null}
                  </Table.Summary.Cell>

                  {/* เงินรับฝากค่างวด — empty */}
                  <Table.Summary.Cell />

                  {/* รวมรับสุทธิ */}
                  <Table.Summary.Cell align="right" style={cellStyle}>
                    {t.netReceived ? fmtPos(t.netReceived) : null}
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              );

              return (
                <>
                  <SummaryRow
                    label="รวมทั้งหมด"
                    count={filteredData.length}
                    t={totalsAll}
                  />
                  <SummaryRow
                    label="รวมยกเลิกทั้งหมด"
                    count={cancelledRows.length}
                    t={totalsCancelled}
                    style={{ background: "#ffebeb" }}
                    cellStyle={{ color: "#dc3545" }}
                  />
                  <SummaryRow
                    label="รวมรับชำระจริง"
                    count={validRows.length}
                    t={totalsValid}
                    style={{ background: "#d4edda" }}
                    cellStyle={{ color: "#155724" }}
                  />
                </>
              );
            }}
          />
        </Card>
      </Spin>
    </>
  );
};

const MainReportManagerAcc = MotionHoc(Main);
export default MainReportManagerAcc;
